<attributes-editor
  [dataSource]="editorDataSource"
  fxFlexWidth="100%"
  [useAttributeDescription]="true"
  (downloadFile)="downloadFile($event)"
>
</attributes-editor>
<button
  mat-raised-button
  class="large"
  [disabled]="!isSurveyValid() || isSaving"
  appThrottleClick
  (throttledClick)="saveSurvey()"
>
  Submit Survey
</button>
